module.exports = __webpack_public_path__ + "img/454.a86cfb61.png";